import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import inventory from "../../../Data/inventory.json";
import products from "../../../Data/products.json";
import { get_all_inventories } from "../../../Controllers/Inventory/Batch";
import toast from "react-hot-toast";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import { get_all_inventories_expired_reports } from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";

const InventoryExpired = () => {
  let location = useLocation();
  let componentRef = useRef();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [role, setRole] = useState("");

  const headers = {
    name: "Inventory batch",
    pagination: {
      currentPage: 1,
      totalCount: 0,
      totalPages: 0,
    },
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        value: null,
        allowClear: true,
        options: [
          { value: "1", label: "Name (A-Z)" },
          { value: "2", label: "Name (Z-A)" },
          { value: "3", label: "Expiry (ASC)" },
          { value: "4", label: "Expiry (DES)" },
          { value: "5", label: "Purchase (Low)" },
          { value: "6", label: "Purchase (High)" },
          { value: "7", label: "Sale (Low)" },
          { value: "8", label: "Sale (High)" },
        ],
      },
      {
        type: "filter",
        name: "product",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Product",
        api: "get-all-products",
        source: "report",
        value: null,
        options: null,
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Inventory Expired",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: 0, label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      console.log("ss", tabledata)

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        unit: tabledata?.unit,
        category: tabledata?.category,
        brand: tabledata?.brand,
        type: tabledata?.type,
        status: tabledata?.status,
        page: tabledata?.currentPage,
        product: tabledata?.product,
        date: tabledata?.date
      };

      const products = await get_all_inventories_expired_reports(data);

      if (products?.status) {
        setBody(products?.data?.expired_data);
        setRole(products?.data?.role)
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  const downloadCSV = () => {
    console.log("Download CSV clicked");
    console.log("Body data:", body);

    if (!body || body.length === 0) {
      console.log("No data available for download");
      toast.error("No data available to download");
      return;
    }

    try {
      const header = ["S.No", "Name", "Batch", "Expiry", "Tax", "Stock", "Purchase", "Price/Unit", "Sale", "Total"];

      const rows = body?.map((item, index) => {
        const row = [
          index + 1,
          item?.product_name || "-",
          item?.number ? `#BATCH-${item.number}` : "-",
          formatDate(item?.expiry_date),
          item?.tax || 0,
          item?.stock?.toFixed?.(3) || 0,
          item?.purchase_price?.toFixed?.(3) || 0,
          item?.price_per_unit?.toFixed?.(3) || 0,
          item?.sale_price?.toFixed?.(3) || 0,
          (item?.price_per_unit && item?.sale_price)
            ? (item.price_per_unit * item.sale_price).toFixed(3)
            : 0,
        ];
        return row;
      });

      const csvContent = [header, ...rows]
        .map(row => row.map(field => `"${field}"`).join(","))
        .join("\n");

      const encoder = new TextEncoder();
      const encodedContent = encoder.encode('\uFEFF' + csvContent);

      const blob = new Blob([encodedContent], { type: 'text/csv;charset=utf-8' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `Inventory_Expired_Report_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  const downloadPDF = () => {
    if (!body || body.length === 0) return;

    const doc = new jsPDF();
    registerCairoFont(doc)
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFont("Cairo-Bold", "bold");

    doc.setFontSize(18);
    doc.text("Inventory Expired Report", pageWidth / 2, 18, { align: "center" });

    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB");
    const formattedTime = now.toLocaleTimeString();
    doc.setFontSize(10);
    doc.text(`Downloaded on: ${formattedDate} ${formattedTime}`, pageWidth / 2, 26, { align: "center" });

    const tableRows = body.map((item, index) => [
      index + 1,
      item?.product_name || "-",
      item?.number ? `#BATCH-${item.number}` : "-",
      formatDate(item?.expiry_date),
      item?.tax || 0,
      item?.stock?.toFixed?.(3) || 0,
      item?.purchase_price?.toFixed?.(3) || 0,
      item?.price_per_unit?.toFixed?.(3) || 0,
      item?.sale_price?.toFixed?.(3) || 0,
      (item?.price_per_unit && item?.sale_price)
        ? (item.price_per_unit * item.sale_price).toFixed(3)
        : 0,
    ]);

    autoTable(doc, {
      startY: 32,
      columnStyles: {
        1: { cellWidth: 32 },
        5: { cellWidth: 15 }
      },
      styles: {
        font: "Cairo",
        textColor: [0, 0, 0],
        lineColor: [7, 181, 83],
        lineWidth: 0.2
      },
      headStyles: {
        font: "Cairo",
        fontStyle: "bold",
        fillColor: false,
        lineColor: [7, 181, 83],
        lineWidth: 0.6
      },
      head: [["S.No", "Name", "Batch", "Expiry", "Tax", "Stock", "Purchase", "Price/Unit", "Sale", "Total"]],
      body: tableRows,
    });

    doc.save(`Inventory_Expired_Report_${formattedDate}.pdf`);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!role) return;

    let updatedHeader = { ...headers };

    if (role !== "SUPERADMIN") {
      updatedHeader.components = updatedHeader.components.filter(
        (item) => item.name !== "branch"
      );
    }

    setHeader(updatedHeader);
  }, [role]);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>

        <div className="text-right flex gap-3 justify-end mt-4">
          <Button
            className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
            type="primary"
            onClick={downloadCSV}
          >
            Download CSV
          </Button>

          <ReactToPrint
            trigger={() => (

              <Button
                className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
                type="primary"
              >
                Download PDF
              </Button>
            )}
            content={() => componentRef}
            pageStyle={`
                                 @page {
                                   size: landscape;
                                   margin: 10mm;
                                 }
                   
                                 @media print {
                                   tfoot {
                                     position: static !important;
                                     bottom: auto !important;
                                   }
                                   thead { 
                                     display: table-header-group !important;
                                   }
                                   tfoot {
                                     display: table-row-group !important;
                                   }
                                 }
                   
                                   table {
                                   border-collapse: collapse;
                                   width: 100%;
                                 }
                                 th, td {
                                   border: 1px solid #ddd;
                                   padding: 6px;
                                 }
                                 th {
                                   background-color: #f4f4f4;
                                 }
                                   @media print {

  table, thead, tbody, tfoot, tr, th, td {
    border: 1px solid #000 !important;
    border-collapse: collapse !important;
  }

  th {
    background-color: #f4f4f4 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  table {
    width: 100% !important;
    border-collapse: collapse !important;
  }

  thead, tfoot {
    position: static !important;
  }
}
                               `}
          />
        </div>
        <ScrollWrapper>
          <div
            className="max-h-[70vh] overflow-y-auto scrollbar-hide remove-scroll-limit"
            ref={(el) => (componentRef = el)}
          >
            <table className="w-full bg-white">
              <thead className="text-gray-500 sticky top-0 bg-white z-10">
                <tr>
                  <td className="border p-4">S.No</td>
                  <td className="border p-4">Name</td>
                  <td className="border p-4">Batch</td>
                  <td className="border p-4">Expiry</td>
                  <td className="border p-4">Tax</td>
                  <td className="border p-4">Stock</td>
                  <td className="border p-4">Purchase</td>
                  <td className="border p-4">Price/unit</td>
                  <td className="border p-4">Sale</td>
                </tr>
              </thead>
              <tbody>
                {body?.map((value, index) => {
                  return (
                    <tr>
                      <td className="border p-4">{index + 1}</td>
                      <td className="border p-4">{value?.product?.name}</td>
                      <td className="border p-4">{value?.number}</td>
                      <td className="border p-4">
                        {value?.expiry_date
                          ? moment?.(value?.expiry_date)?.format("DD/MM/YYYY")
                          : ""}
                      </td>
                      <td className="border p-4">{value?.tax}</td>
                      <td className="border p-4">{value?.stock?.toFixed?.(3)}</td>
                      <td className="border p-4">
                        {value?.purchase_price?.toFixed(3)}
                      </td>
                      <td className="border p-4">
                        {value?.price_per_unit?.toFixed?.(3)}
                      </td>
                      <td className="border p-4">
                        {value?.sale_price?.toFixed?.(3)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot className="sticky bottom-0 bg-white z-10">
                <tr className="text-sm font-medium">
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.stock),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.purchase_price),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.price_per_unit),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.sale_price),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default InventoryExpired;
